// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__qRNGx","tabsBox":"styles_tabsBox__KR_UP","createButton":"styles_createButton__1IyV-"};